import React, { useState, useEffect } from "react";
import { Select } from "antd";
import TextField from "../../Commons/Forms/TextField";
import TextArea from "../../Commons/Forms/TextArea";
import BtnClear from "../../Commons/Buttons/BtnClear";
import BtnClearDropdown from "../../Commons/Buttons/BtnClearDropdown";
import BtnSave from "../../Commons/Buttons/BtnSave";
import BtnDelete from "../../Commons/Buttons/BtnDelete";
import DateField from "../../Commons/Forms/DateField";
import ViewPrescription from "../../AssessmentHistory/ViewPrescription";
import PrintDiagnostics from "../../../Pages/CheckupTabs/PrintDiagnostics";
import PrintLaboratoryDiagnostics from "../../Diagnosis/PrintLaboratoryDiagnostics";
import PrintXrayDiagnostics from "../../Diagnosis/PrintXrayDiagnostics";
import PrintCTScanDiagnostics from "../../Diagnosis/PrintCTScanDiagnostics";
import PrintUltrasoundDiagnostics from "../../Diagnosis/PrintUltrasoundDiagnostics";
import BirForm from "../../AssessmentHistory/PrintEkas";
import PrintEpress from "../../AssessmentHistory/PrintEpress.js";
import { useNavigate } from "react-router-dom";

import { useParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { Radio } from "antd";
import {
  createOutPatient,
  endConsultation,
  getTherapeutics,
  updateOutPatient,
  updateCheckUp,
} from "../../Helpers/API/CheckUpApi/CheckUpApi";
import { toast } from "react-toastify";
import { validateOutpatientForm } from "../../Helpers/Utilities/Validations/CheckUp";
import { getAssessmentForPrint } from "../../Helpers/API/AssessmentApi/AssessmentApi";
import { formatDate, getRole, getUser, refreshPage } from "../../Helpers/Utilities/Common";

const { Option } = Select;

function OutPatient({
  assessmentId,
  addCheckUpData,
  showAdmit,
  showOutPatient,
  addOutPatientData,
  setAddOutPatientData,
  fetchAssessmentHistory,
  patientDetails,
  diagnostics,
  doctorOptions,
  printDiagnostics,
  selectedTab,
  setSelectedTab,
  selectedFormTab,
  setSelectedFormTab,
}) {
  const navigate = useNavigate();
  const { id } = useParams();
  const role = getRole();
  const userId = getUser();
  const [isClicked, setIsClicked] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [therapeutics, setTherapeutics] = useState(false);
  const [showViewPrescriptionModal, setShowViewPrescriptionModal] =
    useState(false);
  const [showPrintLabDiagnosticsModal, setShowPrintLabDiagnosticsModal] =
    useState(false);
  const [showPrintXrayDiagnosticsModal, setShowPrintXrayDiagnosticsModal] =
    useState(false);
  const [showPrintCTScanDiagnosticsModal, setShowPrintCTScanDiagnosticsModal] =
    useState(false);
  const [
    showPrintUltrasoundDiagnosticsModal,
    setShowPrintUltrasoundDiagnosticsModal,
  ] = useState(false);
  const [isError, setIsError] = useState({
    professional_fee: false,
    hmo_type: false,
    corporate_type: false,
    // hmo_id: false,
    reference_no: false,
  });

  const [selectedPatientDetails, setSelectedPatientDetails] = useState([]);
  const [showPrintEkas, setShowPrintEkas] = useState(false);
  const [showPrintEpress, setShowPrintEpress] = useState(false);

  const menu = [
    { key: "laboratory", label: "Laboratory" },
    { key: "xray", label: "X-Ray" },
    { key: "ct_scan", label: "CT Scan" },
    { key: "ultrasound", label: "Ultrasound" },
  ];

  // Filter menu items where corresponding printDiagnostics type
  const filteredMenu = (() => {
    const validItems = menu.filter((item) => {
      const key = item.key;
      return (
        printDiagnostics[key] &&
        Array.isArray(printDiagnostics[key]) &&
        printDiagnostics[key].length > 0
      );
    });

    return validItems.length > 0
      ? validItems
      : [{ key: "none", label: "No diagnostics available", disabled: true }];
  })();

  // Function for showing which diagnostic to print
  function handlePrintDiagnostics(menu) {
    if (menu === "laboratory") {
      setShowPrintLabDiagnosticsModal(true);
    } else if (menu === "xray") {
      setShowPrintXrayDiagnosticsModal(true);
    } else if (menu === "ct_scan") {
      setShowPrintCTScanDiagnosticsModal(true);
    } else if (menu === "ultrasound") {
      setShowPrintUltrasoundDiagnosticsModal(true);
    }
  }

  // Function for showing rx modal
  const handlePrintRx = () => {
    fetchPatientTherapeutics();
    setShowViewPrescriptionModal(true);
  };

  // Function get therapeutic API
  async function fetchPatientTherapeutics() {
    const res = await getTherapeutics({
      patient_id: id,
      assessment_id: assessmentId,
    });

    if (res.data) {
      const filtered = (Array.isArray(res.data) ? res.data : []).filter(
        (t) => t?.quantity !== undefined && t?.quantity !== null && t?.quantity !== "" && t?.quantity !== "null"
      );
      setTherapeutics(filtered);
    } else if (res.error) {
      setTherapeutics([]);
    }
  }

  async function handleEndConsultation() {

    const res = await endConsultation({
      assessment_id: assessmentId,
      type: "outpatient",
      status: "ended",
    });

    if (res.data) {
      toast.success(res.data.message);
      navigate("/patients");
    } else if (res.error) {
      res.error.data.messages.error_messages.forEach((errMsg) =>
        toast.error(errMsg)
      );
    }
  }

  // Function for handling values of input fields
  const handleAddChange = (e) => {
    const { name, value } = e.target;
    if (name === "professional_fee_method" && value === "No PF") {
      setAddOutPatientData((prevState) => ({
        ...prevState,
        professional_fee: "0",
        [name]: value,
      }));
    } else if (name === "professional_fee_method" && value === "cash") {
      setAddOutPatientData((prevState) => ({
        ...prevState,
        professional_fee: patientDetails.doctor_id === "3" ? "500" : "450",
        [name]: value,
      }));
    } else if (name === "professional_fee_method" && value === "gcash") {
      setAddOutPatientData((prevState) => ({
        ...prevState,
        professional_fee: "",
        [name]: value,
      }));
    } else if (name === "professional_fee_method" && value === "hmo") {
      setAddOutPatientData((prevState) => ({
        ...prevState,
        professional_fee: patientDetails.hmo_type ? "0" : "",
        [name]: value,
      }));
    } else if (name === "professional_fee_method" && value === "corporate") {
      setAddOutPatientData((prevState) => ({
        ...prevState,
        professional_fee: patientDetails.corporate_type ? "0" : "",
        [name]: value,
      }));
    }
    setAddOutPatientData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling assigned doctor field
  function handleDoctorChange(value) {
    setAddOutPatientData((prevState) => ({
      ...prevState,
      doctor_id: value,
    }));
  }

  // Function create outpatient API
  async function addOutPatient() {
    setIsClicked(true);
    if (validateOutpatientForm(addOutPatientData, setIsError)) {
      const response = await createOutPatient(
        addOutPatientData,
        id,
        assessmentId,
        patientDetails.doctor_id
      );
      if (response.data) {
        toast.success(response.data.message);
        fetchAssessmentHistory();
      } else if (response.error) {
        response.error.data.messages.error_messages.forEach((errMsg) =>
          toast.error(errMsg)
        );
      }
    }
    setIsClicked(false);
  }

  async function addAdmission() {
    setIsClicked(true);
    addCheckUpData.from_type = "outpatient";
    addCheckUpData.type = "for_admission";
    const response = await updateCheckUp(addCheckUpData, id);
    if (response.data) {
      toast.success(response.data.message);
      showAdmit(true);
      showOutPatient(false);
      setTimeout(() => {
        refreshPage();
      }, 1000);
    }
    setIsClicked(false);
  }

  async function addReferral() {
    setIsClicked(true);
    setSelectedTab("forms");
    setSelectedFormTab("referral_letter");
    setIsClicked(false);
  }

  // Function edit outpatient API
  async function editOutPatient() {
    setIsClicked(true);
    setIsSaving(true);
    try {
      if (validateOutpatientForm(addOutPatientData, setIsError)) {
        const response = await updateOutPatient(
          addOutPatientData,
          id,
          assessmentId,
          addOutPatientData.id,
          patientDetails.doctor_id
        );
        if (response.data) {
          toast.success(response.data.message);
        } else if (response.error) {
          response.error.data.messages.error_messages.forEach((errMsg) =>
            toast.error(errMsg)
          );
        }
      }
    } finally {
      setIsClicked(false);
      setIsSaving(false);
    }
  }

  useEffect(() => {
    if (role !== "nurse") {
      setAddOutPatientData((prevState) => ({
        ...prevState,
        doctor_id: userId,
      }));
    }
  }, []);


  // Print Ekas functionality
  async function handlePrintEkas() {
    const response = await getAssessmentForPrint({
      assessment_id: assessmentId,
      patient_id: id,
    });
    if (response?.data) {
      setSelectedPatientDetails(response.data.data);
      setShowPrintEkas(true);
      handleGenerateEkasForm();
    } else {
      response?.error?.data?.messages?.error_messages?.forEach((err) =>
        toast.error(err || "Failed to fetch data.")
      );
    }
  }

  // Print Epress functionality
  async function handlePrintEpress() {
    const response = await getAssessmentForPrint({
      assessment_id: assessmentId,
      patient_id: id,
    });
    if (response?.data) {
      setSelectedPatientDetails(response.data.data);
      setShowPrintEpress(true);
      handleGenerateEpressForm();
    } else {
      response?.error?.data?.messages?.error_messages?.forEach((err) =>
        toast.error(err || "Failed to fetch data.")
      );
    }
  }

  async function handleGenerateEkasForm() {
    toast.loading("Printing Ekas Form");
    // Wait for component to render, then check if DOM is ready
    setTimeout(() => {
      toast.dismiss();
      waitForElementAndPrint("printablediv", executeEkasPrint);
    }, 1500);
  }

  async function handleGenerateEpressForm() {
    toast.loading("Printing Epress Form");
    // Wait for component to render, then check if DOM is ready
    setTimeout(() => {
      toast.dismiss();
      waitForElementAndPrint("printablediv2", executeEpressPrint);
    }, 1500);
  }

  function waitForElementAndPrint(elementId, printFunction) {
    const checkElement = () => {
      const element = document.getElementById(elementId);
      if (element && element.innerHTML && element.innerHTML.trim().length > 100) {
        printFunction();
      } else {
        // Try again after a short delay
        setTimeout(checkElement, 200);
      }
    };
    checkElement();
  }

  function executeEkasPrint() {
    const printElement = document.getElementById("printablediv");
    if (!printElement || !printElement.innerHTML) {
      toast.error("Print content not ready. Please try again.");
      setShowPrintEkas(false);
      return;
    }
    
    let printContents = printElement.innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    setShowPrintEkas(false);
    refreshPage();
  }

  function executeEpressPrint() {
    const printElement = document.getElementById("printablediv2");
    if (!printElement || !printElement.innerHTML) {
      toast.error("Print content not ready. Please try again.");
      setShowPrintEpress(false);
      return;
    }
    
    let printContents = printElement.innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    setShowPrintEpress(false);
    refreshPage();
  }


  return (
    <div className="tabs-box p-3">
      <div className="col mt-4">
        <div className="">
          <Row>
            <Col xs={4}>
              <DateField
                id="followup_on"
                name="followup_on"
                formLabel={`Follow Up Date`}
                size={`sm`}
                value={addOutPatientData.followup_on}
                onChange={handleAddChange}
                disabled={isClicked}
              />
            </Col>
            {role === "nurse" && (
              <>
                <Col xs={4}>
                  <div className="row">
                    <p className="m-0">
                      Assigned Doctor<span className="red"> *</span>
                    </p>
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Select Doctor"
                      value={addOutPatientData.doctor_id} // Use selected doctor
                      onChange={(value) => {
                        handleDoctorChange(value);
                      }}
                      allowClear
                      options={doctorOptions}
                      optionFilterProp="label"
                      showSearch
                    />
                  </div>
                </Col>
              </>
            )}
          </Row>
          <Row>
            <Col xs={3}>
              <TextField
                id="sales_invoice_no"
                name="sales_invoice_no"
                formLabel={`Sales Invoice No.`}
                size={`sm`}
                value={addOutPatientData.sales_invoice_no || ""}
                onChange={handleAddChange}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <TextField
                required
                id="professional_fee"
                name="professional_fee"
                formLabel={`Professional Fee (Php)`}
                size={`sm`}
                disabled={
                  addOutPatientData.professional_fee_method === "No PF" ||
                  isClicked
                }
                value={addOutPatientData.professional_fee || ""}
                onChange={handleAddChange}
                isError={isError.professional_fee}
                setIsError={setIsError}
                errorMessage="Professional fee is required."
              />
            </Col>
            <Col className="pf-method">
              <p className="form-label align-left">
                PF Method <span className="badge">*</span>
              </p>
              <Radio.Group
                name="professional_fee_method"
                buttonStyle="solid"
                value={addOutPatientData.professional_fee_method}
                style={{ width: "100%" }}
                onChange={handleAddChange}
                disabled={isClicked}
              >
                <Radio.Button
                  value="cash"
                  className={
                    addOutPatientData.professional_fee_method === "cash"
                      ? "pf-button"
                      : ""
                  }
                >
                  Cash
                </Radio.Button>
                <Radio.Button
                  value="gcash"
                  className={
                    addOutPatientData.professional_fee_method === "gcash"
                      ? "pf-button"
                      : ""
                  }
                >
                  GCash
                </Radio.Button>
                {/* <Radio.Button
                  value="hmo"
                  className={
                    addOutPatientData.professional_fee_method === "hmo"
                      ? "pf-button hmo"
                      : ""
                  }
                >
                  Insurance
                </Radio.Button>
                <Radio.Button
                  value="corporate"
                  className={
                    addOutPatientData.professional_fee_method === "corporate"
                      ? patientDetails?.corporate_type?.toLowerCase() ===
                        "gmc-mg"
                        ? "pf-button corporate-orange"
                        : "pf-button corporate-yellow"
                      : ""
                  }
                >
                  Corporate
                </Radio.Button> */}
                <Radio.Button
                  value="No PF"
                  className={
                    addOutPatientData.professional_fee_method === "No PF"
                      ? "pf-button"
                      : ""
                  }
                >
                  No PF
                </Radio.Button>
              </Radio.Group>
            </Col>
          </Row>
          {addOutPatientData.professional_fee_method === "gcash" && (
            <Row>
              <Col xs={6}>
                <TextField
                  required
                  id="reference_no"
                  name="reference_no"
                  formLabel={`Reference No.`}
                  size={`sm`}
                  value={addOutPatientData.reference_no}
                  onChange={handleAddChange}
                  isError={isError.reference_no}
                  setIsError={setIsError}
                  errorMessage="GCash reference no. is required."
                />
              </Col>
            </Row>
          )}
          {addOutPatientData.professional_fee_method === "hmo" && (
            <>
              <Row>
                <Col>
                  <TextField
                    required
                    id="hmo_type"
                    name="hmo_type"
                    formLabel={`HMO Type`}
                    size={`sm`}
                    value={addOutPatientData.hmo_type}
                    onChange={handleAddChange}
                    isError={isError.hmo_type}
                    setIsError={setIsError}
                    errorMessage="HMO type is required."
                  />
                </Col>
                <Col>
                  <TextField
                    // required
                    id="hmo_id"
                    name="hmo_id"
                    formLabel={`HMO ID`}
                    size={`sm`}
                    value={addOutPatientData.hmo_id}
                    onChange={handleAddChange}
                    // isError={isError.hmo_id}
                    // setIsError={setIsError}
                    // errorMessage="HMO ID is required."
                  />
                </Col>
              </Row>
            </>
          )}
          {addOutPatientData.professional_fee_method === "corporate" && (
            <>
              <Row>
                <Col>
                  <TextField
                    required
                    id="corporate_type"
                    name="corporate_type"
                    formLabel={`Corporate Type`}
                    size={`sm`}
                    value={addOutPatientData.corporate_type}
                    onChange={handleAddChange}
                    isError={isError.corporate_type}
                    setIsError={setIsError}
                    errorMessage="Corporate type is required."
                  />
                </Col>
                <Col>
                  <TextField
                    // required
                    id="corporate_id"
                    name="corporate_id"
                    formLabel={`Corporate ID`}
                    size={`sm`}
                    value={addOutPatientData.corporate_id}
                    onChange={handleAddChange}
                    // isError={isError.corporate_id}
                    // setIsError={setIsError}
                    // errorMessage="Corporate ID is required."
                  />
                </Col>
              </Row>
            </>
          )}
          {/* <div className="row">
            <div>
              <TextArea
                id="plan"
                name="plan"
                formLabel={`Plan`}
                size={`lg`}
                value={addOutPatientData.plan}
                onChange={handleAddChange}
                disabled={isClicked}
              />
            </div>
          </div> */}

          <hr />
          <Row className="justify-content-end mt-5 mb-3">
            {addOutPatientData?.id && (
              <Col xs={3}>
                <BtnClear
                  label={"Print Rx"}
                  size={"sm"}
                  onClick={handlePrintRx}
                />
              </Col>
            )}
            {addOutPatientData?.id && (
              <Col xs={3}>
                <BtnClearDropdown
                  label={"Print Diagnostics"}
                  size={"sm"}
                  menuItems={filteredMenu}
                  onSelect={(key) => {
                    if (key !== "none") handlePrintDiagnostics(key);
                  }}
                  disabled={false}
                />
              </Col>
            )}
            {!addOutPatientData.id && (
              <Col xs={3}>
                <>
                  <BtnClear
                    label={"For Referral"}
                    size={"sm"}
                    onClick={addReferral}
                    isClicked={isClicked}
                  />
                </>
              </Col>
            )}
            {/* {!addOutPatientData.id && (
              <Col xs={3}>
                  <>
                    <BtnDelete
                      label={"For Admission"}
                      size={"sm"}
                      onClick={addAdmission}
                      isClicked={isClicked}
                    />
                  </>
              </Col>
            )} */}
            <Col xs={3}>
              {addOutPatientData.id ? (
                <BtnSave
                  label={"Save Changes"}
                  size={"sm"}
                  onClick={editOutPatient}
                  isClicked={isClicked}
                  disabled={Object.values(
                    addOutPatientData.professional_fee
                  ).every((value) => value === "")}
                />
              ) : (
                <>
                  <BtnSave
                    label={"Submit Follow-up Date & PF"}
                    size={"sm"}
                    onClick={addOutPatient}
                    isClicked={isClicked}
                    disabled={Object.values(
                      addOutPatientData.professional_fee
                    ).every((value) => value === "")}
                  />
                </>
              )}
            </Col>
          </Row>
          <Row className="justify-content-end ">
          {addOutPatientData?.id && (
              <>
                <Col xs={3}>
                  <BtnSave
                    label={"Print eKas"}
                    size={"sm"} 
                    onClick={handlePrintEkas}
                    isClicked={isSaving}
                    disabled={isSaving}
                  />
                </Col>
                <Col xs={3}>
                  <BtnSave
                    label={"Print ePresS"}
                    size={"sm"}
                    onClick={handlePrintEpress}
                    isClicked={isSaving}
                    disabled={isSaving}
                  />
                </Col>
                <Col xs={3}>
                  <BtnDelete
                    label={"End Consultation"}
                    size={"sm"}
                    onClick={handleEndConsultation}
                    isClicked={isClicked || isSaving}
                    disabled={isSaving}
                  />
                </Col>
              </>
            )}
          </Row>
        </div>
      </div>

      {/* Printable Ekas/Epress templates - only render when needed */}
      {showPrintEkas && <BirForm data={selectedPatientDetails} />}
      {showPrintEpress && <PrintEpress data={selectedPatientDetails} />}

      <ViewPrescription
        show={showViewPrescriptionModal}
        onHide={() => setShowViewPrescriptionModal(false)}
        therapeutics={therapeutics}
        assessmentId={assessmentId}
        patient={{
          ...patientDetails,
          assessment_date:
            patientDetails.is_sunday_patient !== "1"
              ? formatDate(patientDetails.added_on)
              : formatDate(patientDetails.last_checkup_date),
          address: [
            patientDetails?.street,
            patientDetails?.barangay,
            patientDetails?.province,
            patientDetails?.city,
            patientDetails?.zip_code,
          ]
            .filter(Boolean)
            .join(", "),
        }}
        doctor={patientDetails}
      />
      {/* <PrintDiagnostics
        show={showPrintDiagnosticsModal}
        onHide={() => setShowPrintDiagnosticsModal(false)}
        diagnostics={diagnostics}
        printDiagnostics={printDiagnostics}
        assessmentId={assessmentId}
        patient={patientDetails}
      /> */}

      <PrintLaboratoryDiagnostics
        show={showPrintLabDiagnosticsModal}
        onHide={() => setShowPrintLabDiagnosticsModal(false)}
        diagnostics={diagnostics}
        printDiagnostics={printDiagnostics}
        assessmentId={assessmentId}
        patient={patientDetails}
      />

      <PrintXrayDiagnostics
        show={showPrintXrayDiagnosticsModal}
        onHide={() => setShowPrintXrayDiagnosticsModal(false)}
        diagnostics={diagnostics}
        printDiagnostics={printDiagnostics}
        assessmentId={assessmentId}
        patient={patientDetails}
      />

      <PrintCTScanDiagnostics
        show={showPrintCTScanDiagnosticsModal}
        onHide={() => setShowPrintCTScanDiagnosticsModal(false)}
        diagnostics={diagnostics}
        printDiagnostics={printDiagnostics}
        assessmentId={assessmentId}
        patient={patientDetails}
      />

      <PrintUltrasoundDiagnostics
        show={showPrintUltrasoundDiagnosticsModal}
        onHide={() => setShowPrintUltrasoundDiagnosticsModal(false)}
        diagnostics={diagnostics}
        printDiagnostics={printDiagnostics}
        assessmentId={assessmentId}
        patient={patientDetails}
      />
    </div>
  );
}

export default OutPatient;
